import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../AuthContext/AuthContext";

const Header = () => {
  const { user, logout } = useContext(UserContext);
  return (
    <div data-theme="valentine">
      <div className="navbar">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <Link to="/home">Home</Link>
              </li>

              <li>
                <Link to="/services">All Services</Link>
              </li>

              {user && (
                <>
                  <li>
                    <Link to="/myreviews"> My Reviews</Link>
                  </li>
                  <li>
                    <Link to="/add_service">Add Service</Link>
                  </li>
                </>
              )}
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
              {user && (
                <li>
                  <p className="mr-4 block md:hidden">
                    Logged in with : {user?.email}
                  </p>
                </li>
              )}
            </ul>
          </div>
          <Link to="/" className="btn btn-ghost normal-case text-xl">
            Motiur's Chember
          </Link>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal p-0">
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/services">All Services</Link>
            </li>

            {user && (
              <>
                <li>
                  <Link to="/myreviews"> My Reviews</Link>
                </li>
                <li>
                  <Link to="/add_service">Add Service</Link>
                </li>
              </>
            )}
            <li>
              <Link to="/blogs">Blogs</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end">
          {user ? (
            <>
              <p className="mr-4 hidden md:block">
                Logged in with : {user.email}
              </p>
              <Link onClick={logout} className="btn">
                Logout
              </Link>
            </>
          ) : (
            <Link to="/login" className="btn">
              Login
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
